import React from 'react'
import {useTranslation} from 'react-i18next'
import {useBreakpointValue} from '@chakra-ui/react'
import DateCell from './DateCell'
import StatusCell from './StatusCell'
import PayeeWithReferenceCell from './PayeeWithReferenceCell'
import DueAmountCell from './DueAmountCell'
import MCoinCell from './MCoinCell'
import FeeCell from './FeeCell'
import ActionCell from './ActionCell'

const useColumns = ({onSelectPayee}) => {
  const {t} = useTranslation('pointsOnPayments')

  const hidexxl = useBreakpointValue({base: true, '2xl': false})

  const hidexl = useBreakpointValue({base: true, xl: false})

  const columns = React.useMemo(
    () => [
      {
        header: t('pointsOnPayments:bill.table.columns.headers.payee'),
        accessorKey: 'payeeName',
        cell: PayeeWithReferenceCell,
      },
      {
        header: t('pointsOnPayments:bill.table.columns.headers.status'),
        accessorKey: 'status',
        cell: StatusCell,
      },
      {
        header: t('pointsOnPayments:bill.table.columns.headers.issueDate'),
        accessorKey: 'issueDate',
        cell: DateCell,
        hidden: hidexxl,
      },
      {
        header: t('pointsOnPayments:bill.table.columns.headers.dueDate'),
        accessorKey: 'dueDate',
        cell: DateCell,
      },
      {
        header: t('pointsOnPayments:bill.table.columns.headers.paidAmount'),
        accessorKey: 'paidAmount',
        accessorFn: (rowData) => rowData.paidAmount.toFormat(),
        hidden: hidexl,
      },
      {
        header: t('pointsOnPayments:bill.table.columns.headers.dueAmount'),
        accessorKey: 'dueAmount',
        accessorFn: (rowData) => rowData.dueAmount.toFormat(),
        cell: DueAmountCell,
      },
      {
        header: t('pointsOnPayments:bill.table.columns.headers.mPoints'),
        id: 'mcoin',
        accessorFn: (rowData) => rowData.mcoin ?? null,
        hidden: hidexxl,
        cell: MCoinCell,
      },
      {
        header: t('pointsOnPayments:bill.table.columns.headers.fee'),
        id: 'fee',
        accessorFn: (rowData) => rowData.mcoin?.fee ?? null,
        hidden: hidexxl,
        cell: FeeCell,
      },
      {
        header: '',
        accessorKey: 'actionButton',
        meta: {onSelectPayee},
        cell: ActionCell,
      },
    ],
    [hidexxl, hidexl, onSelectPayee],
  )

  return {columns}
}

export default useColumns
